import { featureLabels, MODULE_FEATURE_MAP } from "../constants/availableFeatures";

const normalizeModuleName = (moduleName) => {
  const key = String(moduleName || "").trim().toLowerCase();
  const aliases = {
    payrollmanagement: "payroll",
    "payroll-management": "payroll",
    payroll_management: "payroll",
    attendancemanagement: "attendance",
    "attendance-management": "attendance",
    attendance_management: "attendance",
    employeemanagement: "employees",
    "employee-management": "employees",
    employee_management: "employees",
    changespage: "changesPage",
    configurations: "configurations",
    documents: "documents",
    leaves: "leaves",
    advancement: "advancements",
    advancements: "advancements",
    advancementmanagement: "advancements",
    "advancement-management": "advancements",
    "advancement_management": "advancements",
    salaryadvancements: "advancements",
    solfa: "advancements",
    "solfa-management": "advancements",
    calendar: "calendar",
    reports: "reports",
    calendar: "calendar",
    changespage: "changesPage",
    "changes-page": "changesPage",
    "changes_page": "changesPage",
    messages: "messages",
    adminlevels: "adminLevels",
  };
  return aliases[key] || key;
};

const normalizeFeatureName = (featureName) => {
  const key = String(featureName || "").trim();
  const aliases = {
    dataImport: "import",
    importPayroll: "import",
    importAttendance: "import",
    importAttendanceDeduction: "import",
    importAttendanceDeductions: "import",
    importAllowancesDeductions: "import",
    importAllowanceDeduction: "import",
    dataExport: "export",
    exportPayroll: "export",
    create: "add",
    delete: "remove",
  };
  return aliases[key] || key;
};

export const getFeatureLabel = (featureName, moduleName, language) => {
  const normalizedFeature = normalizeFeatureName(String(featureName || "").trim());
  const normalizedModule = normalizeModuleName(moduleName);

  // Check if module has custom feature map (business-specific labels)
  if (MODULE_FEATURE_MAP[normalizedModule]) {
    const featureMapping = MODULE_FEATURE_MAP[normalizedModule].find(
      (f) => f.key === normalizedFeature || f.key === featureName
    );
    if (featureMapping) {
      return language === "ar" ? featureMapping.arLabel : featureMapping.uiLabel;
    }
  }

  if (normalizedFeature.toLowerCase() === "add" && normalizedModule === "employees") {
    return language === "ar" ? "إضافة موظف جديد" : "Add New Employee";
  }

  return featureLabels[language]?.[normalizedFeature] || featureLabels[language]?.[featureName] || featureName;
};

export const normalizeModuleKey = (moduleName) => normalizeModuleName(moduleName);

export const getCompaniesForClient = (companies, clientName) => {
  const trimmed = String(clientName || "").trim();
  return Array.from(
    new Set(
      (companies || [])
        .filter((c) => String(c?.clientName || "").trim() === trimmed && c?.companyName)
        .map((c) => String(c.companyName).trim())
    )
  );
};

export const safeUserLabel = (u) => {
  const en = (u?.employee?.sr && u.employee.sr.trim()) || (u?.sr && u.sr.trim());
  return en || "Unnamed User";
};